import type { PostgrestError } from '@supabase/supabase-js';

/** True when PostgREST/Postgres reports a missing table, column, or RPC (migrations not applied yet). */
export function isMissingDbObjectError(error: PostgrestError | null | undefined): boolean {
  if (!error) return false;
  const code = error.code ?? '';
  const blob = `${error.message ?? ''} ${error.details ?? ''} ${error.hint ?? ''}`.toLowerCase();
  const status = (error as PostgrestError & { status?: number }).status;
  return (
    status === 404 ||
    status === 405 ||
    code === 'PGRST202' ||
    code === 'PGRST205' ||
    code === '42883' ||
    code === '42703' ||
    code === '25006' ||
    blob.includes('does not exist') ||
    blob.includes('could not find') ||
    blob.includes('not found') ||
    blob.includes('schema cache') ||
    blob.includes('read-only transaction')
  );
}
